import {Stack, useResponsiveValue, Label} from '@primer/react'
import styles from '../marketplace.module.css'
import type {Listing} from '@github-ui/marketplace-common'
import {VerifiedIcon} from '@primer/octicons-react'
import {ListingLogo} from './ListingLogo'

interface OverviewHeaderProps {
  listing: Listing
  breadcrumbs: React.ReactNode
  banner?: React.ReactNode
  listingDetails: React.ReactNode
  additonalDetails: React.ReactNode
  delistButton: React.ReactNode
  callToAction: React.ReactNode
}

export function OverviewHeader(props: OverviewHeaderProps) {
  const isMobile = useResponsiveValue({narrow: true}, false) as boolean
  const {listing, breadcrumbs, banner, listingDetails, additonalDetails, delistButton, callToAction} = props
  const {name} = listing

  let label = ''
  let isVerifiedOwner = false

  if (listing.type === 'repository_action') {
    label = 'Actions'
    isVerifiedOwner = listing.isVerifiedOwner
  }

  return (
    <Stack data-testid="overview-header">
      <Stack direction={'horizontal'} justify={'space-between'}>
        {breadcrumbs}
        {delistButton}
      </Stack>
      <div className={`${styles['marketplace-banner-container']}`}>{banner}</div>
      <Stack justify={'space-between'} className={'flex-column flex-md-row'}>
        <Stack align={'center'} direction={'horizontal'}>
          <div className={`${styles['marketplace-logo-wrapper']}`}>
            <ListingLogo listing={listing} />
            {isVerifiedOwner && (
              <div className={`${styles['marketplace-logo__verified-icon-wrapper']}`}>
                <VerifiedIcon size={16} className={'fgColor-accent'} aria-label={'Verified'} />
              </div>
            )}
          </div>
          <Stack align={'center'} direction={'horizontal'} gap={'condensed'}>
            <h1 className={isMobile ? 'h4' : 'h3'}>{name}</h1>
            {label && (
              <Label variant="secondary" className={'d-none d-md-flex'} data-testid="type-label">
                {label}
              </Label>
            )}
          </Stack>
        </Stack>

        <Stack className={'d-md-none'}>{listingDetails}</Stack>

        {callToAction}

        <Stack className={'d-md-none width-full'}>{additonalDetails}</Stack>
      </Stack>
    </Stack>
  )
}

try{ OverviewHeader.displayName ||= 'OverviewHeader' } catch {}